export default [
  {
    path: '/activity-20251001-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-10-30T23:59:59.000+08:00', title: '秋日集市' },
  },
  {
    path: '/activity-20251001-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-10-30T23:59:59.000+08:00', title: '秋日集市-规则说明' },
  },
]
